<template>
    <div>
        <Unionpay />
    </div>
</template>

<script>
import Unionpay from "./unionpayView.vue";
export default {
    components: {
        Unionpay,
    },
    data() {
        return{
            
        }
    },
    created(){
        
    }
};
</script>
